import { ReactNode } from 'react'

interface SectionContentProps {
  title: string
  className?: string
  children: ReactNode
}

export function SectionContent({
  title,
  className = '',
  children,
}: SectionContentProps) {
  return (
    <section className={`px-lg md:px-md ${className}`}>
      <div className="grid-cols-12 gap-y-8 rounded-lg px-lg py-8 bg-primary-5 md:px-md md:py-10 lg:grid">
        <h2 className="col-span-3 text-base font-semibold tracking-widest text-primary md:text-xl">
          {title}
        </h2>
        <div className="col-span-8 mt-8 lg:mt-0">{children}</div>
      </div>
    </section>
  )
}
